import React, { useCallback, useState, useMemo } from "react";
import Select from "react-select";

import CampaignCreateTeaserEditor from "../../Campaign__Create_TeaserEditor/Campaign__Create_TeaserEditor.jsx";
import logger from "../../../../../utils/LoggerFrontend.js";
import { spotifySamples } from "./AudioTextSamples.constants.jsx";
import { teaserTextStyle, TextEditorWrapper } from "./AudioTextSamples.styled.js";
import { AlternativeSection, TextSectionWrapper } from "../AudioGenerator/AudioGenerator.styled.js";
import { t } from "i18next";

const branche = Array.from(new Set(spotifySamples.map(({ branche }) => branche)))
  .map((branche) => ({ label: branche, value: branche }))
  .concat([{ value: "Alle", label: "Alle" }]);

export const AudioTextSamples = ({ updateAudioData, setUseGen }) => {
  const [selectedCategory, setSelectedCategory] = useState("Alle");

  const handleChangeCategory = useCallback(({ value }) => {
    setSelectedCategory(value);
  }, []);

  const handleSelectText = useCallback(
    (selectedText) => {
      logger.log("AudioTextSamples:handleSelectText", "called", { selectedText });
      setUseGen(false);
      updateAudioData({ key: "audioText", value: selectedText });
    },
    [updateAudioData, setUseGen]
  );

  const currentlySelectedCategory = useMemo(
    () => branche.filter(({ value }) => value === selectedCategory)[0],
    [selectedCategory]
  );

  const filteredText = useMemo(() => {
    if (selectedCategory == "Alle") {
      return spotifySamples;
    }
    return spotifySamples.filter(({ branche }) => branche === selectedCategory);
  }, [selectedCategory]);

  return (
    <AlternativeSection>
      <TextSectionWrapper>
        <label>{t("Select industry")}</label>
        <Select
          options={branche}
          onChange={handleChangeCategory}
          value={currentlySelectedCategory}
        />
      </TextSectionWrapper>
      <TextSectionWrapper>
        <label>{t("AUDIO VERSION")}</label>
        {filteredText.map(({ text }) => (
          <TextEditorWrapper key={text} onClick={() => handleSelectText(text)}>
            <CampaignCreateTeaserEditor
              showTeaserRecommendations={false}
              channel=""
              updatePost={updateAudioData}
              teaserText={text || ""}
              postDataKey={"audioText"}
              editable={false}
              teaserTextStyle={teaserTextStyle}
              smallButtons={true}
              placeholder={"Aussage"}
              disableEmojis={true}
            />
          </TextEditorWrapper>
        ))}
      </TextSectionWrapper>
    </AlternativeSection>
  );
};
